import { ReportData } from '../types/reportTypes';
import { combineReports } from '../utils/reportAggregationUtils';
import { codySalesApril2026Data } from './codySalesApril2026Data';
import { codySalesMay2026Data } from './codySalesMay2026Data';
import { codySalesJune2026Data } from './codySalesJune2026Data';

// Q2 2026 Cody Direct Sales Report - aggregates April, May, and June 2026
const allMonthlyReports = [
  codySalesApril2026Data,
  codySalesMay2026Data,
  codySalesJune2026Data
];

const combinedData = combineReports(allMonthlyReports, 'Q2 2026 Cody Direct Sales Report');

export const codySalesQ2_2026Data: ReportData = {
  ...combinedData,
  period: {
    month: 4,
    year: 2026,
    quarter: 2,
    startMonth: 4,
    endMonth: 6
  }
};
